/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoTrattamentoCreateDTO
 */
export interface TipoTrattamentoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoTrattamentoCreateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the TipoTrattamentoCreateDTO interface.
 */
export function instanceOfTipoTrattamentoCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function TipoTrattamentoCreateDTOFromJSON(json: any): TipoTrattamentoCreateDTO {
    return TipoTrattamentoCreateDTOFromJSONTyped(json, false);
}

export function TipoTrattamentoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoTrattamentoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function TipoTrattamentoCreateDTOToJSON(value?: TipoTrattamentoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

